module.exports = __webpack_public_path__ + "img/icon-topic-chat.44b4e723.svg";